<template>
  <div ref="pageRoot" :class="['table-list-root', { 'theme-pink': isPink }]" :style="isPink ? pinkPageStyle : null">
    <div class="table-search-section list-section search-section">
      <Search :isType='isNormalInquiry' @searchData='searchData'>
        <template v-slot:add>
          <el-form-item v-if="isPink && userPermissions.indexOf('inquiry_create') !== -1" class="pink-add-form-item">
            <el-button class="pink-add-btn" type="primary" size="mini" @click='addTable'>新增{{ isNormalInquiry ? '普通' : '全案大全' }}询单
            </el-button>
          </el-form-item>
          <div v-else-if="userPermissions.indexOf('inquiry_create') !== -1" style='float: right;margin-right: 10px' @click='addTable' class='ripple_content ripple_success'>新增{{ isNormalInquiry ? '普通' : '全案大全' }}询单
          </div>
        </template>
        <template v-slot:export>
          <el-button type='text' @click='exportExcel'
                     v-if="userPermissions.indexOf('inquiry_export') !== -1">
            <i class='el-icon-download'></i>
            导出
          </el-button>
        </template>
        <template v-slot:run_script>
          <el-button type='text' @click='runScript'
                     v-if="userPermissions.indexOf('inquiry_order_stat') !== -1">
            <i class='el-icon-refresh' />
            关联订单
          </el-button>
        </template>
      </Search>
    </div>
    <div class="table-body-section list-section table-section">
      <el-tabs class="list-tabs" @tab-click='handleClick' v-model='activeName'>
        <el-tab-pane :label='`全部`'
                     name='all' v-if="tableData&&userPermissions.indexOf('inquiry_all_projects') !== -1">
        </el-tab-pane>
        <el-tab-pane :label='`我的`'
                     name='my'>
        </el-tab-pane>
        <el-tab-pane :label='`我组的`'
                     name='myGroup' v-if="userPermissions.indexOf('inquiry_owner_group_projects') !== -1">
        </el-tab-pane>
      </el-tabs>
      <div ref="tableWrap" class='default-table table-wrap'
           v-loading='loading'
           element-loading-text='加载中……'
           element-loading-spinner='el-icon-loading'>
        <el-table
          v-if="isPink"
          :data="tableData"
          class="inquiry-table"
          :row-class-name="tableRowClassName"
          :height="tableBodyHeight"
          style="width: 100%">
          <el-table-column align="center" label="ID" width="80" show-overflow-tooltip>
            <template slot-scope="{row}">
              {{ countText(row.id) }}
            </template>
          </el-table-column>

          <el-table-column align="center" label="创建时间" width="110" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="create-time">{{ $utils.parseTime(row.created_at, '{y}-{m}-{d}') }}</span>
            </template>
          </el-table-column>

          <el-table-column label="项目名称" min-width="320" show-overflow-tooltip>
            <template slot-scope="{row}">
              <div class="project-cell">
                <div class="project-name-line">
                  <el-link
                    v-if="userPermissions.indexOf('inquiry_project_detail') !== -1"
                    class="project-link"
                    :title="row.name || '-'"
                    @click="detailPage(row.id)">
                    {{ row.name || '-' }}
                  </el-link>
                  <span v-else class="project-name" :title="row.name || '-'">{{ row.name || '-' }}</span>
                  <span class="assign-tag" v-if="formatYesNo(row.is_assign) === '是'">定向</span>
                </div>
                <div class="project-sub" v-if="formatIntentions(row.intentions)">
                  意向达人: {{ formatIntentions(row.intentions) }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="品牌" min-width="140" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="primary-text" :title="row.brand || '-'">{{ row.brand || '-' }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="isNormalInquiry ? '合作平台' : '直播平台'" min-width="300">
            <template slot-scope="{row}">
              <el-tooltip
                v-if="formatPlatforms(row.platforms).length"
                :content="formatPlatforms(row.platforms).join('、')"
                placement="top">
                <div class="platform-list">
                  <span
                    v-for="platform in formatPlatforms(row.platforms).slice(0, 3)"
                    :key="platform"
                    class="platform-chip">
                    {{ platform }}
                  </span>
                  <span v-if="formatPlatforms(row.platforms).length > 3" class="platform-more">...</span>
                </div>
              </el-tooltip>
              <span v-else class="muted">-</span>
            </template>
          </el-table-column>

          <el-table-column label="合作形式" min-width="120" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{ formatCoop(row.coop) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="档期" width="220" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span class="date-range" :class="{ 'date-urgent': isDateUrgent(row) }">{{ formatDateRange(row.expect_start, row.except_end) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" header-align="left" label="报名进度" width="260">
            <template slot-scope="{row}">
              <div class="progress-cell">
                <div class="progress-track" aria-hidden="true">
                  <span
                    v-for="stage in progressStages(row)"
                    :key="stage.key"
                    class="progress-segment"
                    :class="{ active: stage.active }"></span>
                </div>
                <div class="progress-summary">{{ progressText(row) }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="报名人数" width="90">
            <template slot-scope="{row}">
              <span class="primary-text">{{ enrollCountText(row.enroll_num) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="报名人" min-width="220">
            <template slot-scope="{row}">
              <el-tooltip
                v-if="formatEnrollers(row.enroll_nms).length"
                :content="formatEnrollers(row.enroll_nms).join('、')"
                placement="top">
                <div class="enroller-list">
                  <el-tag
                    v-for="name in formatEnrollers(row.enroll_nms).slice(0, 3)"
                    :key="name"
                    effect="plain"
                    size="mini">
                    {{ name }}
                  </el-tag>
                  <el-tag
                    v-if="formatEnrollers(row.enroll_nms).length > 3"
                    type="info"
                    effect="plain"
                    size="mini">
                    ...
                  </el-tag>
                </div>
              </el-tooltip>
              <span v-else class="muted">-</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" header-align="center" align="left" label="操作" width="200">
            <template slot-scope="{row}">
              <div class="action-list">
                <template v-for="(btn, index) in getActionButtons(row)">
                  <el-button
                    v-if="index < 2"
                    :key="btn.key"
                    :type="btn.type"
                    :plain="btn.plain"
                    size="mini"
                    :icon="btn.icon"
                    @click="btn.handler(row)">
                    {{ btn.text }}
                  </el-button>
                </template>
                <el-dropdown
                  v-if="getActionButtons(row).length > 2"
                  class="more-dropdown"
                  trigger="click"
                  @command="handleActionCommand($event, row)">
                  <el-button size="mini" icon="el-icon-more" class="more-btn" />
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="btn in getActionButtons(row).slice(2)"
                      :key="btn.key"
                      :command="btn.key"
                      :icon="btn.icon">
                      {{ btn.text }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else :data='tableData' border
                  stripe
                  id='id'
                  :row-class-name='tableRowClassName'
                  style='width: 100%'>
          <el-table-column
            align='center'
            label='序号'
            type='index'
            width='60'
            fixed='left'
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='创建日期'
            prop='created_at'
            width='100'
            fixed='left'
          >
            <template slot-scope='{row}'>
              {{ $utils.parseTime(row.created_at, '{y}-{m}-{d}') }}
            </template>

          </el-table-column>
          <el-table-column
            align='center'
            label='查看'
            type='index'
            width='80'
            fixed='left'
          >
            <template slot-scope='{row}'>
              <el-link @click='handleDbclick(row)' size='mini' icon='el-icon-s-marketing' type='primary'
                       v-if="row?.status!==3&&row?.status!==2&&((activeName === 'all' && userPermissions.indexOf('inquiry_update_all') !== -1) || (activeName !== 'all' && userPermissions.indexOf('inquiry_update') !== -1))">
                详情
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align='center' label='ID' prop='id' width='80' show-overflow-tooltip />
          <el-table-column
            align='center'
            label='项目名称'
            min-width='160'
            prop='name'
            show-overflow-tooltip
            fixed='left'
          >
            <template slot-scope='{row}'>
              <el-link @click='detailPage(row.id)' size='mini'
                       type='primary' :class="{ 'project-link': isPink }"
                       v-if="userPermissions.indexOf('inquiry_project_detail') !== -1">
                <span>{{ row.name }}</span>
              </el-link>
              <span v-else :class="{ 'project-name': isPink }">{{ row.name }}</span>
            </template>
          </el-table-column>
          <template v-if='isNormalInquiry'>
            <el-table-column
              align='center'
              label='是否定向'
              prop='is_assign'
              width='80'
            >
              <template slot-scope='{row}'>
                <template v-if="isPink">
                  <span class="assign-tag" v-if="row.is_assign === '是'">定向</span>
                  <span class="muted" v-else>-</span>
                </template>
                <template v-else>{{ row.is_assign }}</template>
              </template>
            </el-table-column>
            <el-table-column
              align='center'
              label='意向达人'
              prop='intentions'
              width='120'
              show-overflow-tooltip
            >
              <template slot-scope='{row}'>
                <span :key='i.id' v-for='i in row.intentions'>{{ i.nickname }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            align='center'
            label='品牌'
            prop='brand'
            width='110'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='品牌背书'
            prop='brand_intro'
            width='160'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='产品'
            prop='product'
            width='160'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            :label="isNormalInquiry?'合作平台':'直播平台'"
            prop='platforms'
            :width="isPink ? null : 140"
            :min-width="isPink ? 320 : null"
            show-overflow-tooltip
          >
            <template slot-scope='{row}'>
              <template v-if="isPink">
                <el-tooltip
                  v-if="formatPlatforms(row.platforms).length"
                  :content="formatPlatforms(row.platforms).join('、')"
                  placement="top">
                  <div class="platform-list">
                    <span
                      v-for="platform in formatPlatforms(row.platforms).slice(0, 3)"
                      :key="platform"
                      class="platform-chip">
                      {{ platform }}
                    </span>
                    <span v-if="formatPlatforms(row.platforms).length > 3" class="platform-more">...</span>
                  </div>
                </el-tooltip>
                <span v-else class="muted">-</span>
              </template>
              <template v-else>
                {{ String(row.platforms) }}
              </template>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            label='合作形式'
            prop='coop_id'
            width='140'
            v-if='isNormalInquiry'
            show-overflow-tooltip
          >
            <template slot-scope='{row}'>
              {{ row.coop?.display_name || '暂无' }}
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            width='110'
            label='是否平台下单'
            prop='is_platform_pay'
          >
          </el-table-column>
          <el-table-column
            align='center'
            width='110'
            label='是否寄回'
            prop='is_send_back'
          >

          </el-table-column>
          <!--        <el-table-column-->
          <!--            align='center'-->
          <!--            label='是否佣金/挂车'-->
          <!--            prop='is_cart'-->
          <!--            -->
          <!--        >-->
          <!--        </el-table-column>-->
          <el-table-column
            align='center'
            label='激励政策'
            prop='cart_mechanism'
            width='160'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='授权平台'
            prop='_auth_platform'
            width='180'
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='期望档期'
            prop='expect_start'
            width='180'
          >
            <template slot-scope='{row}'>
              {{ row?.expect_start.slice(0, 10) }} 至 {{ row?.except_end.slice(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            label='创建人'
            width='100'
            prop='create_user.nickname'
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='项目状态' prop='status'
          >
            <template slot-scope='{row}'>
              <el-tag
                :type="row?.status == 1 ?'success':'danger'"
                effect='plain'>
                {{ row?.status == 1 ? '进行中' : row?.status == 2 ? '已结束' : row?.status == 3 ? '已作废' : '已完结' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            label='报名状态' prop='is_apply'
            width='100'
          >
            <template slot-scope='{row}'>
              <el-tag
                :type="row?.is_apply == 1 ?'success':'danger'"
                effect='plain'>
                {{ row?.is_apply == 1 ? '正在报名' : row?.is_apply == 2 ? '不可报名' : '结束报名' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            label='确认下单' prop='is_confirm'
            width='100'
          >
            <template slot-scope='{row}'>
              <el-tag
                :type="row?.is_confirm === 1 ?'success':'danger'"
                effect='plain'>
                {{ row?.is_confirm === 1 ? '已确认' : '未确认' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            label='报名人数'
            prop='enroll_num'
            width='150'
          >
          </el-table-column>
          <el-table-column
            align='center'
            label='报名人'
            prop='enroll_nms'
            width='300'
          >
          </el-table-column>
          <el-table-column fixed='right' header-align='center' align='left' label='操作' width='240'>
            <template slot-scope='{row}'>
              <el-link @click='handleEdit(row.id)' size='mini' icon='el-icon-edit' type='primary'
                       v-if="row?.status!==3&&row?.status!==2&&((activeName === 'all' && userPermissions.indexOf('inquiry_update_all') !== -1) || (activeName !== 'all' && userPermissions.indexOf('inquiry_update') !== -1))">
                编辑
              </el-link>
              <el-link @click="handleVoid(row,'cancel')"
                       style='margin:0 4px' size='mini' type='danger' icon='el-icon-close'
                       v-if="row.details_count==0&&row.status!=3&&userPermissions.indexOf('inquiry_cancel') !== -1">
                作废
              </el-link>
              <el-link @click='setConfirm(row.id, row.is_confirm)'
                       style='margin:0 4px' size='mini' type='danger'
                       :icon="row.is_confirm === 1? 'el-icon-refresh-left' : 'el-icon-success'"
                       v-if="activeName !== 'all' && userPermissions.indexOf('inquiry_confirm') !== -1">
                {{ row.is_confirm === 1 ? '取消确认' : '确认下单' }}
              </el-link>
              <el-link @click="handleVoid(row,'del')" style='margin:0 4px' type='danger' size='mini' icon='el-icon-delete'
                       v-if="((activeName === 'all' && userPermissions.indexOf('inquiry_delete_all') !== -1) || (activeName !== 'all' && userPermissions.indexOf('inquiry_delete') !== -1))">
                删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div ref="paginationWrap" class="pagination-wrap">
          <Pagination :limit.sync='pageInfo.page_size'
                      :page.sync='pageInfo.current_page'
                      :total='pageInfo.total'
                      @pagination='emitData()' />
        </div>
      </div>
    </div>

    <!--    添加-->
    <CreateEdit v-if='drawerVisible' :drawerVisible.sync='drawerVisible' :rowId='rowId'></CreateEdit>
    <YearFrameCreateEdit v-if='yearDrawerVisible' :drawerVisible.sync='yearDrawerVisible'
                         :rowId='rowId'></YearFrameCreateEdit>
    <!--作废确认框-->
    <el-dialog
      :title="handleData.type === 'cancel'?`请输入（${handleData.data?.name}）作废原因`:`请输入要删除的项目名称（${handleData.data?.name}）`"
      :visible.sync='dialogVisible' height='30%' width='30%'>

      <el-input
        clearable
        placeholder='请输入'
        v-model='cancel_reason'>
        <i :class='changeBlur' :style="changeBlur=='el-icon-check'?{color:'#67C23A'}:''" slot='suffix'
           style='line-height: 30px'></i>
      </el-input>
      <span style='font-size: 12px;display: block;float: right;margin-top: 12px;color: red'
            v-if="changeBlur=='el-icon-check'">删除需谨慎</span>

      <span class='dialog-footer' slot='footer'>
        <el-button @click='dialogVisible = false'>取 消</el-button>
        <el-button @click='cancel' type='primary'>确 定</el-button>
      </span>
    </el-dialog>
    <!--    导出进度-->
    <el-dialog
      :visible.sync='downloadLoading'
      width='50%'
      :destroy-on-close='true'
      :close-on-click-modal='true'
      :show-close='loadingEnd'
      @close='initDown'
    >
      <div class='loadingBox'>
        <div class='left'>
          <video width='80%' height='80%'
                 :src='require(`@/assets/loading/bg.mp4`)'
                 muted='true'
                 autoplay='true' auto-rotate='false' playsinline='true' x5-playsinline='true'
                 webkit-playsinline='true' t7-video-player-type='inline' crossorigin='anonymous'
                 loop='true'></video>
        </div>
        <div class='right'>
          <el-progress :width='250' style='margin-top: 30px' type='dashboard'
                       :percentage='percentage>100? 100 : percentage'
                       :color='colors'></el-progress>
        </div>
        <br />

      </div>
      <div class='bottom'>
        <h1>
          {{ loadingEnd ? `内容导出成功，共计【${downDataList.length}】条数据` : '内容导出中，请勿刷新或关闭窗口' }}
        </h1>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import CreateEdit from '../CreateEdit'
import InfoDetail from '../InfoDetail'
import {mapGetters} from 'vuex'
import Search from './search'
import * as XLSX from 'xlsx-js-style'
import YearFrameCreateEdit from '@/pages/inquiries/yearFrameCreateEdit.vue'
import {parseTime} from "@/utils";

export default {
  name: 'tableList',
  components: { CreateEdit, InfoDetail, Search, YearFrameCreateEdit },
  computed: {
    ...mapGetters(['userPermissions']),
    changeBlur() {
      let returnData = ''
      if (this.handleData.type === 'cancel') {
        returnData = 'el-icon-edit'
      } else {
        if (this.cancel_reason != this.handleData.data?.name) {
          returnData = 'el-icon-edit'
        } else
          returnData = 'el-icon-check'
      }
      return returnData
    },
    isNormalInquiry() {
      return this.categoryType === 'normal'
    },
    isPink() {
      return this.theme === 'pink'
    },
    isYearFrame() {
      return this.categoryType === 'year'
    },
    pinkPageStyle() {
      if (!this.isPink || !this.pageHeight) {
        return null
      }
      return {
        height: `${this.pageHeight}px`
      }
    }
  },
  data() {
    return {
      pageHeight: 0,
      tableBodyHeight: 360,
      drawerVisible: false,
      loading: false,
      rowId: 'add',
      searchDatas: {},
      pageInfo: {
        total: 0,
        page_size: 15,
        offset: 0,
        current_page: 1
      },
      dialogVisible: false,
      cancel_reason: '',
      handleData: {},
      activeName: 'my',
      counts: '',
      downDataList: [],
      downloadLoading: false,
      percentage: 0,
      colors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 }
      ],
      loadingEnd: false,
      exportId: null,
      yearDrawerVisible: null,
      pinkResizeObserver: null
    }
  },
  props: {
    tableData: {
      type: Array,
      required: true
    },
    tablePagination: {
      type: Object
    },
    type: {
      type: String,
      default: 'my'
    },
    categoryType: {
      type: String,
      default: 'normal'
    },
    isActive: {
      type: [Number, String]
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  watch: {
    drawerVisible: {
      handler(val) {
        if (!val) {
          this.emitData()
        }

      }
    },
    yearDrawerVisible: {
      handler(val) {
        if (!val) {
          this.emitData()
        }
      }
    },
    tablePagination: {
      handler(val) {
        this.pageInfo = val
        if (this.isPink) {
          this.updatePinkLayout()
        }
      }
    },
    tableData: {
      handler(val) {
        if (!val) {
          this.tableData = val
        }
      }
    }
  },
  methods: {
    hasValue(value) {
      if (Array.isArray(value)) {
        return value.length > 0
      }
      return value !== undefined && value !== null && value !== ''
    },
    formatTextList(value, labelKeys = ['display_name', 'platform_name', 'name', 'label', 'value']) {
      if (Array.isArray(value)) {
        return value.map((item) => {
          if (!item || typeof item !== 'object') {
            return item
          }
          const key = labelKeys.find((labelKey) => this.hasValue(item[labelKey]))
          return key ? item[key] : ''
        }).filter(Boolean)
      }
      if (typeof value === 'string') {
        return value.split(/[,，、/]/).map((item) => item.trim()).filter(Boolean)
      }
      if (value && typeof value === 'object') {
        return this.formatTextList(Object.values(value), labelKeys)
      }
      return []
    },
    formatPlatforms(platforms) {
      return this.formatTextList(platforms)
    },
    formatIntentions(intentions) {
      return this.formatTextList(intentions, ['nickname', 'display_name', 'name']).join('、')
    },
    formatEnrollers(value) {
      return this.formatTextList(value, ['nickname', 'display_name', 'name', 'label', 'value'])
    },
    formatCreator(value) {
      if (!value) {
        return '-'
      }
      if (typeof value === 'string') {
        return value
      }
      return value.nickname || value.display_name || value.name || '-'
    },
    formatCoop(coop) {
      if (!coop) {
        return '-'
      }
      if (typeof coop === 'string') {
        return coop
      }
      return coop.display_name || coop.name || '-'
    },
    formatAuthPlatform(row) {
      return row._auth_platform || this.formatYesNo(row.is_auth_price)
    },
    countText(value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    sumColonNumbers(value) {
      if (value === undefined || value === null || value === '') {
        return 0
      }
      if (typeof value === 'number') {
        return value
      }
      const text = String(value)
      const reg = /[：:]\s*(\d+(?:\.\d+)?)/g
      let total = 0
      let matched = false
      let match = reg.exec(text)
      while (match) {
        matched = true
        total += Number(match[1])
        match = reg.exec(text)
      }
      if (matched) {
        return total
      }
      const num = Number(text)
      return Number.isNaN(num) ? 0 : num
    },
    enrollCountText(value) {
      if (value === undefined || value === null || value === '') {
        return '-'
      }
      return this.sumColonNumbers(value)
    },
    pickNumber(source, keys) {
      for (const key of keys) {
        const value = source && source[key]
        if (value !== undefined && value !== null && value !== '') {
          return this.sumColonNumbers(value)
        }
      }
      return 0
    },
    progressCounts(row) {
      return {
        apply: this.pickNumber(row, ['apply_count', 'details_count', 'enroll_num']),
        employ: this.pickNumber(row, ['employ_count']),
        confirm: this.pickNumber(row, ['confirm_count'])
      }
    },
    progressStages(row) {
      const counts = this.progressCounts(row)
      return [
        { key: 'apply', active: counts.apply > 0 },
        { key: 'employ', active: counts.employ > 0 },
        { key: 'confirm', active: counts.confirm > 0 }
      ]
    },
    progressText(row) {
      const counts = this.progressCounts(row)
      return `报名${counts.apply} · 初选${counts.employ} · 合作${counts.confirm}`
    },
    formatDate(value) {
      return value ? String(value).slice(0, 10) : '-'
    },
    formatDateRange(start, end) {
      const startText = this.formatDate(start)
      const endText = this.formatDate(end)
      if (startText === '-' && endText === '-') {
        return '-'
      }
      return `${startText} 至 ${endText}`
    },
    isDateUrgent(row) {
      const endText = this.formatDate(row.except_end)
      if (endText === '-') {
        return false
      }
      const end = new Date(endText.replace(/-/g, '/'))
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const diffDays = Math.round((end - today) / 86400000)
      return diffDays >= 0 && diffDays <= 3
    },
    formatYesNo(value) {
      if (value === '是' || value === '否') {
        return value
      }
      if (value === 1 || value === '1' || value === 2 || value === '2' || value === true) {
        return '是'
      }
      if (value === 0 || value === '0' || value === false) {
        return '否'
      }
      return value || '-'
    },
    canPreview(row) {
      return ((this.activeName === 'all' && this.userPermissions.indexOf('inquiry_update_all') !== -1) ||
        (this.activeName !== 'all' && this.userPermissions.indexOf('inquiry_update') !== -1)) &&
        row?.status !== 3 && row?.status !== 2
    },
    canEdit(row) {
      return this.canPreview(row)
    },
    canCancel(row) {
      return row.details_count == 0 && row.status != 3 && this.userPermissions.indexOf('inquiry_cancel') !== -1
    },
    canConfirm() {
      return this.activeName !== 'all' && this.userPermissions.indexOf('inquiry_confirm') !== -1
    },
    canDelete() {
      return (this.activeName === 'all' && this.userPermissions.indexOf('inquiry_delete_all') !== -1) ||
        (this.activeName !== 'all' && this.userPermissions.indexOf('inquiry_delete') !== -1)
    },
    hasRowActions(row) {
      return this.canPreview(row) || this.canEdit(row) || this.canCancel(row) || this.canConfirm(row) || this.canDelete(row)
    },
    updatePinkLayout() {
      if (!this.isPink) {
        return
      }
      this.$nextTick(() => {
        const rootEl = this.$refs.pageRoot
        const tableWrap = this.$refs.tableWrap
        const paginationWrap = this.$refs.paginationWrap
        if (!rootEl || !tableWrap) {
          return
        }
        const nextPageHeight = Math.max(480, window.innerHeight - rootEl.getBoundingClientRect().top)
        if (nextPageHeight !== this.pageHeight) {
          this.pageHeight = nextPageHeight
        }
        const nextTableHeight = Math.max(220, tableWrap.clientHeight - (paginationWrap ? paginationWrap.offsetHeight : 0))
        if (nextTableHeight !== this.tableBodyHeight) {
          this.tableBodyHeight = nextTableHeight
        }
      })
    },
    bindPinkLayout() {
      if (!this.isPink || this.pinkResizeObserver) {
        return
      }
      if (typeof ResizeObserver !== 'undefined' && this.$refs.tableWrap) {
        this.pinkResizeObserver = new ResizeObserver(() => {
          this.updatePinkLayout()
        })
        this.pinkResizeObserver.observe(this.$refs.tableWrap)
      }
      window.addEventListener('resize', this.updatePinkLayout)
    },
    unbindPinkLayout() {
      if (this.pinkResizeObserver) {
        this.pinkResizeObserver.disconnect()
        this.pinkResizeObserver = null
      }
      window.removeEventListener('resize', this.updatePinkLayout)
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    handleDbclick(row) {
      this.$emit('rowDbclick', row.index)
    },
    initDown() {
      this.loadingEnd = false
      this.percentage = 0
      this.downDataList = []
    },

    async startRecordExport() {
      const data = {
        'condition': { ...this.searchDatas },
        'type': this.type
      }
      return await this.$api.recordExportInquiry(data)
    },
    async endRecordExport() {
      const data = {
        'id': this.exportId,
        'rows_count': this.downDataList.length
      }
      await this.$api.recordExportInquiry(data)
    },
    // 下载表格
    async exportExcel() {
      this.downloadLoading = true
      this.exportId = null
      //记录导出信息
      const id = await this.startRecordExport()
      if (id) {
        this.exportId = id
        await this.getAllData()
      }
    },

    async getAllData() {
      const pageData = {
        page_size: 100,
        current_page: this.pageInfo.current_page,
        total: this.pageInfo.total
      }

      await this.getDownList(pageData)
      if (this.downDataList.length !== 0 && this.downDataList.length === pageData.total) {
        // const xlsxParam = { raw: false } //转换成excel时，使用原始的格式
        /* 生成工作表 */
        const workbook = XLSX.utils.book_new()
        let header = []
        let data = []
        let ExcelName = '普通询单列表'
        if (this.isNormalInquiry) {
          header = ['序号', '创建日期', 'ID', '项目名称', '是否定向', '意向达人', '品牌', '品牌背书', '产品'
            , '合作平台', '合作形式', '是否平台下单', '是否寄回', '激励政策', '授权平台',
            '期望档期', '直播明细', '其他要求', '创建人', '项目状态', '报名状态', '报名人数', '报名人']
          data = this.downDataList.map((item, i) => {
            return {
              '序号': i + 1,
              '创建日期': parseTime(item.created_at, '{y}-{m}-{d}'),
              'ID': item.id,
              '项目名称': item.name,
              '是否定向': item.is_assign,
              '意向达人': item?.kols,
              '品牌': item.brand,
              '品牌背书': item?.brand_intro == null ? '' : item.brand_intro || '暂无',
              '产品': item.product,
              '合作平台': String(item.platforms),
              '合作形式': item?.coop?.display_name,
              '是否平台下单': item?.is_platform_pay,
              '是否寄回': item.is_send_back === 1 ? '是' : '否',
              '激励政策': item.cart_mechanism || '',
              '授权平台': item.is_auth_price === 1 ? '是' : '否',
              '期望档期': `${parseTime(item?.expect_start.slice(0, 10), '{y}-{m}-{d}')} 至 ${parseTime(item?.except_end.slice(0, 10), '{y}-{m}-{d}')}`,
              '直播明细': item.live_detail || '',
              '其他要求': item.other_desc || '',
              '创建人': item?.create_user?.nickname || '',
              '项目状态': item.status,
              '报名状态': item.is_apply,
              '报名人数': item.enroll_num,
              '报名人': item.enroll_nms
            }
          })
        } else {
          header = ['序号', '创建日期', 'ID', '项目名称', '品牌', '品牌背书', '产品'
            , '直播平台', '是否平台下单', '是否寄回', '有无特别激励政策', '授权平台'
            , '期望档期', '直播明细', '其他要求', '创建人', '项目状态', '报名状态', '报名人数', '报名人']
          data = this.downDataList.map((item, i) => {
            return {
              '序号': i + 1,
              '创建日期': parseTime(item.created_at, '{y}-{m}-{d}'),
              'ID': item.id,
              '项目名称': item.name,
              '品牌': item.brand,
              '品牌背书': item?.brand_intro == null ? '' : item.brand_intro || '暂无',
              '产品': item.product,
              '直播平台': String(item.platforms),
              '是否平台下单': item.is_platform_pay,
              '是否寄回': item.is_send_back === 1 ? '是' : '否',
              '有无特别激励政策': item.cart_mechanism || '',
              '授权平台': item.is_auth_price === 1 ? '是' : '否',
              '期望档期': `${parseTime(item?.expect_start.slice(0, 10), '{y}-{m}-{d}')} 至   ${parseTime(item?.except_end.slice(0, 10), '{y}-{m}-{d}')}`,
              '直播明细': item.live_detail || '',
              '其他要求': item.other_desc || '',
              '创建人': item?.create_user?.nickname || '',
              '项目状态': item.status,
              '报名状态': item.is_apply,
              '报名人数': item.enroll_num,
              '报名人': item.enroll_nms
            }
          })
          ExcelName = '年框大全案询单列表'
        }
        const belong = this.isActive === 'all' ? '全部' : this.isActive === 'my' ? '我的' : '我组的'
        let ws = XLSX.utils.json_to_sheet(data, { header: header })
        ws = this.worksheetStyle(ws)
        XLSX.utils.book_append_sheet(workbook, ws, ExcelName)
        XLSX.writeFile(workbook, `${belong}${ExcelName}.xlsx`)
        this.loadingEnd = true
      }
    }
    ,
    worksheetStyle: function(worksheet) {
      const HEADER_FS = 9    // 表头字号
      const BODY_FS = 9      // 正文字号
      const FONT = 'Microsoft YaHei'
      const HEADER_BG = 'fce2eb'

      // 按「列名 -> 列宽(字符数)」配置，避免用索引猜列导致加字段后错位
      const COL_WIDTH = {
        '序号': 6,
        '创建日期': 12,
        'ID': 8,
        '项目名称': 30,
        '是否定向': 10,
        '意向达人': 24,
        '品牌': 18,
        '品牌背书': 24,
        '产品': 24,
        '合作平台': 20,
        '直播平台': 20,
        '合作形式': 16,
        '是否平台下单': 12,
        '是否寄回': 10,
        '激励政策': 22,
        '有无特别激励政策': 22,
        '授权平台': 10,
        '期望档期': 36,
        '直播明细': 40,
        '其他要求': 40,
        '创建人': 12,
        '项目状态': 12,
        '报名状态': 12,
        '报名人数': 10,
        '报名人': 30
      }
      const DEFAULT_WCH = 18

      // 通过第一行表头拿到列顺序，再生成 !cols
      const range = XLSX.utils.decode_range(worksheet['!ref'])
      const cols = []
      for (let c = range.s.c; c <= range.e.c; c++) {
        const headCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: c })]
        const headText = headCell ? String(headCell.v).trim() : ''
        cols.push({ wch: COL_WIDTH[headText] || DEFAULT_WCH })
      }
      // !cols 需要覆盖到数据最右列，避免尾列宽度丢失
      for (let c = cols.length; c <= 30; c++) {
        cols.push({ wch: DEFAULT_WCH })
      }
      worksheet['!cols'] = cols

      const headerStyle = {
        font: { sz: HEADER_FS, name: FONT, bold: true, color: { rgb: '333333' } },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        fill: { fgColor: { rgb: HEADER_BG } },
        border: {
          top: { style: 'thin', color: { rgb: 'e8b7c8' } },
          bottom: { style: 'thin', color: { rgb: 'e8b7c8' } },
          left: { style: 'thin', color: { rgb: 'e8b7c8' } },
          right: { style: 'thin', color: { rgb: 'e8b7c8' } }
        }
      }
      const bodyCenterStyle = {
        font: { sz: BODY_FS, name: FONT },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: {
          top: { style: 'thin', color: { rgb: 'f0f0f0' } },
          bottom: { style: 'thin', color: { rgb: 'f0f0f0' } },
          left: { style: 'thin', color: { rgb: 'f0f0f0' } },
          right: { style: 'thin', color: { rgb: 'f0f0f0' } }
        }
      }
      // 长文本列靠左，读起来更整齐
      const bodyLeftStyle = JSON.parse(JSON.stringify(bodyCenterStyle))
      bodyLeftStyle.alignment.horizontal = 'left'

      // 需要左对齐的长文本列
      const LEFT_ALIGN_HEADERS = ['项目名称', '品牌', '品牌背书', '产品', '意向达人',
        '激励政策', '有无特别激励政策', '期望档期', '直播明细', '其他要求', '报名人']
      const leftColIndex = []
      for (let c = range.s.c; c <= range.e.c; c++) {
        const headCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: c })]
        const headText = headCell ? String(headCell.v).trim() : ''
        if (LEFT_ALIGN_HEADERS.includes(headText)) leftColIndex.push(c)
      }

      Object.keys(worksheet).forEach(key => {
        if (key.startsWith('!')) return
        const cell = worksheet[key]
        const addr = XLSX.utils.decode_cell(key)
        if (addr.r === 0) {
          cell.s = headerStyle
          cell.t = 's'
        } else {
          const isNum = typeof cell.v === 'number' && Number.isFinite(cell.v)
          // 文本列保持字符串类型，避免长文本被当成数字
          cell.t = isNum ? 'n' : 's'
          cell.s = leftColIndex.includes(addr.c) ? bodyLeftStyle : bodyCenterStyle
        }
      })
      return worksheet
    },

    async getDownList(pageData) {
      const searchCond = { ...this.searchDatas, current_page: pageData.current_page, page_size: pageData.page_size }
      let list = []
      let page_info = {}
      let data = []
      //
      // if (this.type === 'all') {
      //   let data = await this.$api.listInquiryProject(Object.assign(searchCond))
      //   list = data.list
      //   page_info = data.page_info
      //
      // }
      // if (this.type === 'my') {
      //   if (Number(this.isActive) === 0) {
      //     let data = await this.$api.listInquiryOwner(Object.assign(searchCond))
      //     list = data.list
      //     page_info = data.page_info
      //
      //   } else {
      //     let data = await this.$api.ownerGroup(Object.assign(searchCond))
      //     list = data.list
      //     page_info = data.page_info
      //   }
      // }
      //普通询单=1 全案询单=2
      searchCond.type = this.isNormalInquiry ? 1 : 2

      if (this.isActive === 'all') {
        data = await this.$api.listInquiryProject(searchCond)
      }
      if (this.isActive === 'my') {
        data = await this.$api.listInquiryOwner(searchCond)

      } else if (this.isActive === 'myGroup') {
        data = await this.$api.ownerGroup(searchCond)
      }
      list = data.list
      page_info = data.page_info

      if (this.pageInfo.current_page === 1) {
        if (list.length === 0) {
          this.$message.error('暂无数据')
          this.downloadLoading = false
          return false
        }
      }
      list = list.map((row) => {
        row.status = row?.status == 1 ? '进行中' : row?.status == 2 ? '已结束' : row?.status == 3 ? '已作废' : '已完结'
        row.is_apply = row?.is_apply == 1 ? '报名中' : row?.is_apply == 2 ? '不可报名' : '结束报名'
        const arr = ['is_send_back', 'is_platform_pay', 'is_auth_price', 'is_assign', 'is_cart']
        arr.forEach((i) => {
          row[i] = row?.[i] == 2 ? '否' : '是'
        })
        if (row?.intentions?.length > 0) {
          row.kols = []
          row.intentions.forEach((item) => {
            row.kols.push(item.nickname)
          })
          row.kols = row.kols.toString()
        }
        return row
      })
      this.downDataList = [...this.downDataList, ...list]
      pageData.total = page_info.total
      pageData.current_page = page_info.current_page

      this.percentage = Math.round((pageData.current_page / (page_info.total / 100)) * 100)
      if (this.downDataList.length < pageData.total) {
        pageData.current_page++
        await this.getDownList(pageData)
      } else {
        // 数据加载完毕，通知后台记录导出行为
        //记录导出信息
        await this.endRecordExport()
        return true
      }
    }
    ,
    //
    handleClick() {
      this.pageInfo.current_page = 1
      this.$emit('activeName', this.activeName)
    },
    searchData(val) {
      this.loading = true
      const cond = {
        page_size: this.pageInfo.page_size || 15,
        current_page: 1
      }
      const name = ['name', 'status', 'brand', 'created_start', 'created_end', 'expect_start', 'expect_end', 'is_apply', 'created_by', 'is_confirm', 'product_non_fuzzy']
      name.forEach((type) => {
        if (this.hasValue(val[type])) {
          cond[type] = val[type]
        }
      })
      if (val.intentions?.length) {
        cond['intentions'] = val.intentions
      }
      if (val.platforms?.length) {
        cond['platforms'] = val.platforms
      }

      this.searchDatas = cond
      this.$emit('getTableData', this.searchDatas)
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    emitData() {
      const searchData = { ...this.searchDatas, ...this.pageInfo }
      this.$emit('getTableData', searchData)
    },
    addTable() {
      this.rowId = 'add'
      if (this.isNormalInquiry) {
        this.drawerVisible = true
      } else {
        this.yearDrawerVisible = true
      }
    },
    getActionButtons(row) {
      const buttons = [
        {
          key: 'edit',
          text: '编辑',
          type: 'primary',
          plain: false,
          icon: 'el-icon-edit',
          visible: this.canEdit(row),
          handler: r => this.handleEdit(r.id)
        },
        {
          key: 'confirm',
          text: row.is_confirm === 1 ? '取消' : '确认',
          type: row.is_confirm === 1 ? 'warning' : 'success',
          plain: false,
          icon: row.is_confirm === 1 ? 'el-icon-refresh-left' : 'el-icon-success',
          visible: this.canConfirm(row),
          handler: r => this.setConfirm(r.id, r.is_confirm)
        },
        {
          key: 'cancel',
          text: '作废',
          type: 'danger',
          plain: true,
          icon: 'el-icon-close',
          visible: this.canCancel(row),
          handler: r => this.handleVoid(r, 'cancel')
        },
        {
          key: 'del',
          text: '删除',
          type: 'danger',
          plain: true,
          icon: 'el-icon-delete',
          visible: this.canDelete(row),
          handler: r => this.handleVoid(r, 'del')
        }
      ]
      return buttons.filter(b => b.visible)
    },
    handleActionCommand(key, row) {
      const target = this.getActionButtons(row).find(b => b.key === key)
      if (target) target.handler(row)
    },
    handleEdit(id) {
      this.rowId = id
      if (this.isNormalInquiry) {
        this.drawerVisible = true
      } else {
        this.yearDrawerVisible = true
      }
    },
    handleVoid(rowId, type) {
      this.handleData = { data: rowId, type: type }
      this.dialogVisible = true
    },
    async cancel() {
      // "status": 2 //1:进行中 2:已完结 3:已作废
      if (this.handleData.type === 'cancel') {
        if ((this.cancel_reason || undefined) != undefined) {
          const statusData = {
            id: this.handleData.data.id,
            status: 3,
            cancel_reason: this.cancel_reason
          }
          const id = await this.$api.cancelInquiryStatus(statusData)
          //listInquiryOwner
          if (id) {
            this.$notify.success('作废成功')
            this.dialogVisible = false
            this.emitData()
          }
        } else this.$notify.warning('请输入作废原因')
      } else {
        if (this.cancel_reason === this.handleData.data?.name) {
          const statusData = {
            id: this.handleData.data.id
          }
          const id = await this.$api.delInquiry(statusData)
          //listInquiryOwner
          if (id) {
            this.$notify.success('删除成功')
            this.dialogVisible = false
            this.emitData()
          }
        } else this.$notify.warning('项目名称不正确，删除失败')
      }
    },
    async setConfirm(id, is_confirm) {
      if (id <= 0) {
        this.$notify.error('未找到询单项目id')
        return false
      }
      const msg = is_confirm === 1 ? '取消确认下单' : '确认下单'
      const param = { id: id }
      this.$confirm(`是否` + msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = is_confirm === 1 ? await this.$api.setUnConfirmInquiryProject(param) : await this.$api.setConfirmInquiryProject(param)
        if (info.id) {
          this.$notify.success(msg + '成功')
          this.emitData()
        }
      })
    },
    detailPage(id) {
      this.$router.push({
        name: 'inquiriesDetail',
        params: { id: id }
      })
    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },
    async getCount() {
      if (this.userPermissions.indexOf('inquiry_owner_group_projects') !== -1) {
        this.counts = await this.$api.myCounts()
      }
    },
    async runScript() {
      await this.$api.runScriptInquiryProjectSyncOrderNo()
    }
  },
  mounted() {
    this.pageInfo = this.tablePagination || {}
    this.getCount()
    if (this.isPink) {
      this.bindPinkLayout()
      this.updatePinkLayout()
    }
  },
  beforeDestroy() {
    this.unbindPinkLayout()
  }
}
</script>

<style lang='scss' scoped>
.loadingBox {
  width: 80%;
  margin: 0 auto;
  display: flex;

}

.bottom {
  width: 80%;
  text-align: center;
  margin: 0 auto;
  color: #ff3176;
}

/* ===== 粉色主题（/inquiries/list 启用） ===== */
.table-list-root.theme-pink {
  --list-accent: #ff3176;
  --list-accent-soft: rgba(255, 49, 118, 0.10);
  padding: 10px;
  min-height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  background: #f3f5fa;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.theme-pink .list-section {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 7px rgba(16, 24, 40, 0.05);
}

.theme-pink .search-section {
  padding: 14px 16px 0;
}

.theme-pink .table-section {
  padding: 0 16px 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.theme-pink .table-wrap {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.theme-pink ::v-deep .search-section .el-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.theme-pink ::v-deep .search-section .el-form-item {
  margin: 0 0 10px;
}

.theme-pink .search-section .pink-add-form-item {
  margin-left: auto;
}

.theme-pink ::v-deep .search-section .el-input__inner,
.theme-pink ::v-deep .search-section .el-cascader .el-input__inner {
  height: 32px;
  border-color: #e3e8f2;
  border-radius: 6px;
  background: #f8fafc;
}

.theme-pink ::v-deep .search-section .el-input__inner:focus {
  border-color: var(--list-accent);
  background: #fff;
}

.theme-pink ::v-deep .search-section hr {
  display: none;
}

.theme-pink .search-section .pink-add-btn {
  border: none;
  border-radius: 8px;
  background: var(--list-accent);
  color: #fff;
  box-shadow: 0 6px 14px rgba(255, 49, 118, 0.20);
}

.theme-pink ::v-deep .search-section .el-button--primary,
.theme-pink ::v-deep .table-section .el-button--primary {
  border: none;
  border-radius: 8px;
  background: var(--list-accent);
  color: #fff;
  box-shadow: 0 6px 14px rgba(255, 49, 118, 0.20);
}

.theme-pink ::v-deep .list-tabs .el-tabs__header {
  margin: 0 0 12px;
}

.theme-pink ::v-deep .list-tabs .el-tabs__nav-wrap::after {
  height: 1px;
  background: #edf1f7;
}

.theme-pink ::v-deep .list-tabs .el-tabs__item {
  color: #667085;
  font-weight: 600;
}

.theme-pink ::v-deep .list-tabs .el-tabs__item.is-active {
  color: var(--list-accent);
}

.theme-pink ::v-deep .list-tabs .el-tabs__active-bar {
  background: var(--list-accent);
}

.theme-pink ::v-deep .inquiry-table {
  color: #334155;
  font-size: 13px;
  flex: 1;
}

.theme-pink ::v-deep .inquiry-table::before {
  display: none;
}

.theme-pink ::v-deep .inquiry-table th.el-table__cell {
  background: #f8fafc !important;
  color: #8793a8 !important;
  font-weight: 700 !important;
}

.theme-pink ::v-deep .default-table thead th .cell,
.theme-pink ::v-deep .default-table thead th.is-leaf .cell {
  color: #8793a8 !important;
  font-weight: 700 !important;
  height: 30px !important;
  line-height: 30px !important;
  font-size: 14px !important;
}

.theme-pink ::v-deep .default-table .el-table thead tr,
.theme-pink ::v-deep .default-table .el-table thead th {
  background-color: #f8fafc !important;
  color: #8793a8 !important;
  font-weight: 700 !important;
}

.theme-pink ::v-deep .inquiry-table td.el-table__cell,
.theme-pink ::v-deep .inquiry-table th.el-table__cell {
  border-bottom: 1px solid #edf1f7;
}

.theme-pink ::v-deep .inquiry-table .el-table__fixed-right::before {
  display: none;
}

.theme-pink ::v-deep .inquiry-table .el-table__fixed-right,
.theme-pink ::v-deep .inquiry-table .el-table__fixed-right-patch,
.theme-pink ::v-deep .inquiry-table .el-table__fixed-right .el-table__header-wrapper,
.theme-pink ::v-deep .inquiry-table .el-table__fixed-right .el-table__body-wrapper,
.theme-pink ::v-deep .inquiry-table .el-table__fixed-right td.el-table__cell,
.theme-pink ::v-deep .inquiry-table .el-table__fixed-right th.el-table__cell {
  background: #fff;
}

.theme-pink ::v-deep .inquiry-table .el-table__fixed-right {
  z-index: 8;
  box-shadow: -8px 0 14px rgba(15, 23, 42, 0.06);
}

.theme-pink ::v-deep .inquiry-table .el-table__fixed-right th.el-table__cell {
  background: #f8fafc;
}

.theme-pink .project-link,
.theme-pink .project-name {
  color: #ff3176;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .primary-text {
  color: #0f172a;
  font-weight: 800;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .create-time {
  color: #8a96ab;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  flex-shrink: 0;
}

.theme-pink .project-cell,
.theme-pink .stack-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.theme-pink .project-name-line {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.theme-pink .project-link {
  max-width: 100%;
}

.theme-pink .project-sub,
.theme-pink .sub-text {
  color: #8a96ab;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .project-sub {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.theme-pink .platform-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}

.theme-pink .platform-chip {
  height: 26px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #e3e8f2;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
}

.theme-pink .platform-more {
  height: 26px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  background: #fff0f5;
  color: #ff3176;
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
}

.theme-pink .meta-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px 10px;
}

.theme-pink .meta-line {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  line-height: 1.5;
}

.theme-pink .meta-line-compact {
  align-items: center;
}

.theme-pink .meta-label {
  flex: 0 0 64px;
  color: #8a96ab;
  font-size: 12px;
  white-space: nowrap;
}

.theme-pink .meta-value {
  min-width: 0;
  flex: 1;
  color: #334155;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .assign-tag {
  border: none;
  background: #ffe9f1;
  color: #ff3176;
  font-size: 12px;
  font-weight: 700;
  padding: 0 10px;
  height: 24px;
  line-height: 24px;
  border-radius: 8px;
  display: inline-block;
}

.theme-pink .muted {
  color: #8a96ab;
  font-size: 12px;
}

.theme-pink .status-row {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
}

.theme-pink .date-range {
  color: #475569;
  font-weight: 600;
}

.theme-pink .date-range.date-urgent {
  color: #ec6b6b;
}

.theme-pink .progress-cell {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.theme-pink .progress-track {
  width: 100%;
  max-width: 160px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
}

.theme-pink .progress-segment {
  height: 6px;
  border-radius: 999px;
  background: #e9edf3;
}

.theme-pink .progress-segment.active {
  background: #67c23a;
  box-shadow: 0 0 0 1px rgba(103, 194, 58, 0.08) inset;
}

.theme-pink .progress-summary {
  color: #8a96ab;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme-pink .enroller-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.theme-pink .enroller-list .el-tag {
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theme-pink .action-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.theme-pink .action-list .el-button--mini {
  padding: 5px 8px;
  border-radius: 8px;
}

.theme-pink .more-dropdown {
  display: inline-flex;
  align-items: center;
}

.theme-pink .more-dropdown .more-btn {
  padding: 7px 9px;
  border-radius: 8px;
}

.theme-pink .action-list .el-button--primary {
  border-color: var(--list-accent);
  background: var(--list-accent);
}

.theme-pink .action-list .el-button--success {
  border: none;
  background: #18a058;
  color: #fff;
}

.theme-pink .action-list .el-button--warning {
  border: none;
  background: #f59e0b;
  color: #fff;
}

/* 不可用按钮：灰色禁用态 */
.theme-pink .action-list .el-button.is-disabled,
.theme-pink .action-list .el-button.is-disabled:hover,
.theme-pink .action-list .el-button.is-disabled:focus {
  border-color: #e4e7ed;
  background: #f5f7fa;
  color: #c0c4cc;
}

.theme-pink .pagination-wrap {
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
  flex: none;
}

@media (max-width: 1200px) {
  .theme-pink .list-section {
    padding: 12px;
  }
}
</style>
